// extracted by mini-css-extract-plugin
export default {"not-found__card":"NotFound_not-found__card__Y5nDz"};